import '../../src/create_markup_bread_crumb_list'
import '../../src/preview_buttons'
import '../../src/video_autoplay'

var componentRequireContext = require.context("components", true, /front\/common\/FloatingPromotionBanner/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
